module.exports = __webpack_public_path__ + "static/media/hemachandra.718935ba.jpg";